import { tokens } from 'ComponentLibrary'

export const FUEL_TYPE_COLORS_PALETTE: string[] = [
    tokens.ColorGraphSequentialOneMedium,
    tokens.ColorGraphSequentialTwoMedium,
    tokens.ColorGraphSequentialThreeMedium,
    tokens.ColorGraphSequentialFiveMedium,
    tokens.ColorGraphSequentialSixMedium,
    tokens.ColorGraphSequentialSevenMedium,
    tokens.ColorGraphSequentialEightMedium,
    tokens.ColorGraphSequentialNineMedium,
    tokens.ColorGraphSequentialTenMedium,
    tokens.ColorGraphSequentialOneLight,
    tokens.ColorGraphSequentialTwoLight,
    tokens.ColorGraphSequentialThreeLight,
    tokens.ColorGraphSequentialFiveLight,
    tokens.ColorGraphSequentialSixLight,
    tokens.ColorGraphSequentialSevenLight,
    tokens.ColorGraphSequentialEightLight,
    tokens.ColorGraphSequentialNineLight,
    tokens.ColorGraphSequentialTenLight,
]
